import type { PartyCompositionGroup } from '@/scopes/products/user-reviews/types'
import { useIntl } from '@/intl'
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import { tokPx } from '@sunwebgroup/ui-components'
import { Skeleton, Tag } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import { getPartyCompositionType } from './utils'

const LabelSkeleton = styled(Skeleton)`
  width: 230px;
  height: ${tokPx('components_tag_m_height')};
`

export function MostBookedByLabel() {
  const intl = useIntl()
  const { isLoading, partyCompositionGroups } = useUserReviewsInitialData()

  const mostBookedPartyComposition = partyCompositionGroups?.reduce<PartyCompositionGroup | undefined>(
    (prev, current) => {
      return prev && prev.amount > current.amount ? prev : current
    },
    undefined,
  )

  if (isLoading) {
    return <LabelSkeleton />
  }

  const partyCompositionType = getPartyCompositionType(mostBookedPartyComposition?.groupId ?? '')
  if (partyCompositionType === 'type_unknown') {
    return null
  }

  return (
    <Tag size="M" variant="neutral-tinted" icon="TwoPeople">
      {intl.formatMessage(
        { id: 'description_most_booked_by_label' },
        {
          partyComposition: intl.formatMessage({
            id: `reviews_party_composition_${partyCompositionType}_label`,
          }).toLowerCase(),
        },
      )}
    </Tag>
  )
}
